import { useState } from 'react'
import { useAtomValue } from 'jotai'

import { modalToComponent } from '@/constants/availableModals'
import { useModal } from '@/hooks/useModal'
import { activeModalAtom } from '@/store/activeModal'
import { ModalType } from '@/typings/Modals'

const ActiveModal = ({ type }: { type: ModalType }) => {
  const modal = useModal(type)

  const [isOpen, setIsOpen] = useState(true)

  const ModalComponent = modalToComponent[type]

  return (
    <ModalComponent
      open={isOpen}
      setOpen={() => {
        setIsOpen(false)
        // required for smooth open-close transitions
        setTimeout(() => {
          setIsOpen(true)
          modal.close()
        }, 100)
      }}
    />
  )
}

export default function Modals() {
  const type = useAtomValue(activeModalAtom)

  if (!type) return null

  return <ActiveModal type={type} />
}
